<template>
  <div class="container container-main fixed xl:relative bg-white w-full screen top-[64px] xl:top-0 pb-4 pt-4 overflow-auto">
    <ul ref="listBlock" class="w-full h-screen overflow-auto">
      <ProductSearchItem v-for="product in products" :key="product.sku" :product="product" />
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue"
import ProductSearchItem from "./ProductSearchItem.vue"

defineProps({
  products: {
    type: Array,
    default() {
      return []
    },
  },
})

const emit = defineEmits({
  "scrolled-to-bottom": null,
})

const listBlock = ref(null)

const handleScrollToBottom = (event) => {
  const { scrollHeight, scrollTop, clientHeight } = event.target

  if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
    emit("scrolled-to-bottom")
  }
}

onMounted(() => {
  listBlock.value.addEventListener("scroll", (event) => {
    handleScrollToBottom(event)
  })
})

onBeforeUnmount(() => {
  listBlock.value.removeEventListener("scroll", (event) => {
    handleScrollToBottom(event)
  })
})
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
</style>
